<template>
  <div>
    加载中......
    <!-- [loginCallbackThird Loading]........................
    <br><span>code:{{ code }}</span>
    <br><span>state：{{ state }}</span>
    <br><span>url：{{ url }}</span>
    <br><span>token:{{ token }}</span>
    <br><span>info:{{ info }}</span> -->
  </div>
</template>

<script>
import { getUrlKey } from '@/utils/base'
// const Base64 = require('js-base64').Base64
export default {
  data() {
    return {
      code: undefined,
      state: undefined,
      url: undefined,
      token: undefined,
      info: undefined,
      isFirst: false
    }
  },
  created() {
    this.isFirst = true
    console.log('loginCallback created')
    this.code = getUrlKey('code')
    this.state = getUrlKey('state')
    this.url = getUrlKey('url')
    this.$store.dispatch('user/wechatThirdLogin', {
      code: this.code,
      state: this.state,
      url: this.url
    })
  }
}
</script>

